module.exports = __webpack_public_path__ + "17_vi.png?29ed5a146ff3f4665c6b772b2891b818";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperImg/17_vi.png
// module id = 161
// module chunks = 0